import React, { useState, useMemo,useRef, useEffect  } from "react";
import { Table, Button } from "react-bootstrap";
import { FiCalendar, FiSearch } from "react-icons/fi";
import { CiStopwatch } from "react-icons/ci";
import { FiChevronDown } from "react-icons/fi";

export default function AttendanceTable() {
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [status, setStatus] = useState("All");
  const [range, setRange] = useState("Last 7 Days");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRange, setActiveRange] = useState("Last 7 Days");
  const containerRef = useRef();

  const rangeOptions = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range"
  ];

  // close dropdown
  useEffect(() => {
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  // format date
  const formatDateValue = (date) =>
    date.toLocaleDateString("en-GB");

  // generate date range text
  const generateRangeLabel = () => {
    const today = new Date();
    let start = new Date();

    switch (activeRange) {
      case "Today":
        return `${formatDateValue(today)} - ${formatDateValue(today)}`;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        return `${formatDateValue(start)} - ${formatDateValue(start)}`;

      case "Last 7 Days":
        start.setDate(today.getDate() - 7);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Last 30 Days":
        start.setDate(today.getDate() - 30);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        return `${formatDateValue(start)} - ${formatDateValue(today)}`;

      case "Next Year":
        const nextStart = new Date(today.getFullYear() + 1, 0, 1);
        const nextEnd = new Date(today.getFullYear() + 1, 11, 31);
        return `${formatDateValue(nextStart)} - ${formatDateValue(nextEnd)}`;

      default:
        return "Custom Range";
    }
  };
    // select handler
  const handleRangeChange = (item) => {
    setActiveRange(item);
    setIsMenuOpen(false);
  };

  const data = [
    { date: "02 Sep 2024", in: "09:12 AM", status: "Present", out: "09:17 PM", break: "14 Min", late: "12 Min", overtime: "-", hrs: "8.35" },
    { date: "06 Jul 2024", in: "09:00 AM", status: "Present", out: "07:13 PM", break: "32 Min", late: "-", overtime: "75 Min", hrs: "9.15" },
    { date: "10 Dec 2024", in: "-", status: "Absent", out: "-", break: "-", late: "-", overtime: "-", hrs: "0.00" },
    { date: "12 Apr 2024", in: "09:00 AM", status: "Present", out: "06:43 PM", break: "23 Min", late: "-", overtime: "10 Min", hrs: "8.22" },
    { date: "14 Jan 2024", in: "09:32 AM", status: "Present", out: "06:45 PM", break: "30 Min", late: "32 Min", overtime: "20 Min", hrs: "8.55" },
  ];

  // FILTER LOGIC
  const filtered = useMemo(() => {
    return data
      .filter(d =>
        d.date.toLowerCase().includes(search.toLowerCase())
      )
      .filter(d =>
        status === "All" ? true : d.status === status
      )
      .slice(0, rows);
  }, [search, status, rows]);

  // DATE RANGE LOGIC
  const getRangeText = () => {
    const today = new Date();
    const format = (d) => d.toLocaleDateString("en-GB");

    if (range === "Today") return `${format(today)} - ${format(today)}`;
    if (range === "Yesterday") {
      const y = new Date(today);
      y.setDate(today.getDate() - 1);
      return `${format(y)} - ${format(y)}`;
    }
    if (range === "Last 7 Days") {
      const past = new Date(today);
      past.setDate(today.getDate() - 7);
      return `${format(past)} - ${format(today)}`;
    }
    return "Custom Range";
  };
const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const ref = useRef();

  const options = ["Present", "Absent"];

  // close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

    const [isOpen, setIsOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Last 7 Days");
  const dropdownRef = useRef();

  const sortOptions = [
    "Recently Added",
    "Ascending",
    "Descending",
    "Last Month",
    "Last 7 Days"
  ];

  // outside click close
  useEffect(() => {
    const closeDropdown = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  // handle select
  const handleSelectSort = (option) => {
    setSelectedSort(option);
    setIsOpen(false);
  };
  return (
    <div style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      borderRadius: '5px',
      padding: 20,
      marginTop: 20
    }}>

      {/* HEADER */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 10
      }}>
        <h5>Employee Attendance</h5>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>

          {/* DATE RANGE */}
     <div ref={containerRef} style={{ position: "relative", width: 260 }}>

      {/* TOP INPUT */}
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "10px 12px",
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          background: "#fff",
          fontSize: 14
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiCalendar />
          {generateRangeLabel()}
        </div>
        <FiChevronDown />
      </div>

      {/* DROPDOWN LIST */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "80%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 0",
            zIndex: 1000
          }}
        >
          {rangeOptions.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleRangeChange(item)}
              style={{
                padding: "12px 16px",
                fontSize: 14,
                cursor: "pointer",
                background:
                  activeRange === item ? "#ff6b00" : "transparent",
                color:
                  activeRange === item ? "#fff" : "#111827"
              }}
              onMouseEnter={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (activeRange !== item)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}

      {/* MOBILE */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              width: 100% !important;
              margin-top: 10px !important;
            }
          }
        `}
      </style>
    </div>

          {/* RANGE DROPDOWN */}
    <div ref={ref} style={{ position: "relative",}}>
      
      {/* BUTTON (like your image) */}
      <button
        onClick={() => setOpen(!open)}
        style={{

          // width: "100%",
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          padding: "10px 14px",
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 14,
          cursor: "pointer"
        }}
      >
        {value || "Select Status"}
        <FiChevronDown size={16} />
      </button>

      {/* DROPDOWN LIST */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            overflow: "hidden",
            zIndex: 1000
          }}
        >
          {options.map((item, i) => (
            <div
              key={i}
              onClick={() => {
                setValue(item);
                setOpen(false);
              }}
              style={{
                padding: "14px 16px",
                fontSize: 15,
                cursor: "pointer",
                borderBottom:
                  i !== options.length - 1 ? "1px solid #f1f5f9" : "none",
                background: "#fff"
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f3f4f6")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "#fff")
              }
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>

          {/* STATUS */}
     <div ref={dropdownRef} style={{ position: "relative", width: 230 }}>
      
      {/* BUTTON */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          padding: "10px 14px",
          background: "#f9fafb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          fontSize: 14
        }}
      >
        <span>
          Sort By : <strong style={{color:"#302e2e" }} >{selectedSort}</strong>
        </span>
        <FiChevronDown />
      </div>

      {/* DROPDOWN */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",

            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "10px 0",
            zIndex: 1000
          }}
        >
          {sortOptions.map((item, index) => (
            <div
              key={index}
              onClick={() => handleSelectSort(item)}
              style={{
                padding: "14px 18px",
                fontSize: 15,
                cursor: "pointer"
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f3f4f6")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
        </div>
      </div>
<hr />
      {/* TOP CONTROLS */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 15,
        flexWrap: "wrap"
      }}>

        {/* ROW SELECT */}
        <div>
          Row Per Page
          <select
            value={rows}
            onChange={(e) => setRows(Number(e.target.value))}
            style={{
              marginLeft: 8,
              padding: 3,
              borderRadius: 6
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </select>
        </div>

        {/* SEARCH */}
        <div style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ddd",
          padding: "5px 10px",
          borderRadius: 6
        }}>
          <FiSearch />
          <input
            placeholder="Search"
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "none",
              outline: "none",
              marginLeft: 5
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto", marginTop: 15 }}>
        <Table striped hover>
          <thead style={{ background: "#abb2b8" }}>
            <tr style={{ background: "#abb2b8" }} >
              <th>Date</th>
              <th>Check In</th>
              <th>Status</th>
              <th>Check Out</th>
              <th>Break</th>
              <th>Late</th>
              <th>Overtime</th>
              <th>Production Hours</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((row, i) => (
              <tr key={i}>
                <td>{row.date}</td>
                <td>{row.in}</td>

                {/* STATUS BADGE */}
                <td>
                  <span style={{
                    background: row.status === "Present" ? "#d1fae5" : "#fee2e2",
                    color: row.status === "Present" ? "#16a34a" : "#dc2626",
                    padding: "4px 8px",
                    borderRadius: 6,
                    fontSize: 12
                  }}>
                    ● {row.status}
                  </span>
                </td>

                <td>{row.out}</td>
                <td>{row.break}</td>
                <td>{row.late}</td>
                <td>{row.overtime}</td>

                {/* HOURS BADGE */}
                <td>
                  <span style={{
                    background:
                      row.hrs >= 8 ? "#16a34a" :
                      row.hrs === "0.00" ? "#dc2626" :
                      "#2563eb",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: 6,
                    fontSize: 12
                  }}>
                  <CiStopwatch/> {row.hrs} Hrs
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* MOBILE FIX */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              margin-top: 10px !important;
            }
          }
        `}
      </style>
    </div>
  );
}